<app-fire-foresight-menu></app-fire-foresight-menu>

<div id="content" class="app-content">

  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/home']">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a>Fire Foresight</a>
        </li>
        <li class="breadcrumb-item">
          <a>Cameras</a>
        </li>
      </ol>
    </div>
    <div class="col-lg-2 d-flex align-items-center justify-content-end">
      <div class="btn-group" role="group" aria-label="Cameras view toggle">
        <button
          type="button"
          class="btn btn-sm"
          [class.btn-primary]="currentView === 'list'"
          [class.btn-outline-primary]="currentView !== 'list'"
          (click)="setView('list')"
          title="List View">
          <i class="bi bi-list-ul"></i> List
        </button>
        <button
          type="button"
          class="btn btn-sm"
          [class.btn-primary]="currentView === 'map'"
          [class.btn-outline-primary]="currentView !== 'map'"
          (click)="setView('map')"
          title="Map View">
          <i class="bi bi-map"></i> Map
        </button>
      </div>
    </div>
  </div>
  
  <div class="wrapper wrapper-content animated fadeInRight" >

    <div class="row mt-2" *ngIf="currentView === 'list'">
      <div class="col-lg-4 col-sm-12" *ngFor="let camera of fire.cameras">
        <div class="card mb-4 bg-emphasis bg-opacity-25">
          <div class="card-header">
            <div class="flex-fill px-3">
              <div class="fw-bold">{{camera.name}}</div>
              <div class="small text-inverse text-opacity-50">{{camera.twin?.latestTimeStamp | relativeDate }}</div>
            </div>
          </div>
          <div class="card-body p-0">
            <app-fire-camera-viewer #viewer [siteTwin]="camera.twin" [fullScreen]="true" [autoRotate]="true" [offline]="camera.offline"></app-fire-camera-viewer>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="showNoCamerasListMessage">
      <div class="col-12">
        <div class="alert alert-info text-center mb-0">
          No cameras found.
        </div>
      </div>
    </div>

    <div class="row" *ngIf="currentView === 'map'">
      <div class="col-12">
        <div class="camera-map-shell" *ngIf="!showNoCamerasMapMessage">
          <app-map #map (mapInitComplete)="onMapInitComplete()" ></app-map>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="showNoCamerasMapMessage">
      <div class="col-12">
        <div class="alert alert-info text-center mb-0">
          No cameras found.
        </div>
      </div>
    </div>

    <div class="row" *ngIf="showNoCoordinatesMessage">
      <div class="col-12">
        <div class="alert alert-warning text-center mt-3 mb-0">
          Cameras were loaded, but none have valid coordinates to display on the map.
        </div>
      </div>
    </div>

  </div>
</div>